import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import SubPageNav from "../components/SubPageNav";

export default function Datenschutz() {
  return (
    <div className="min-h-screen bg-brand-bg py-16 px-4">
      <div className="max-w-3xl mx-auto">
        <SubPageNav />

        <h1 className="font-heading text-4xl sm:text-5xl font-bold mb-8">Datenschutzerklärung</h1>

        <div className="space-y-6 text-brand-muted leading-relaxed">
          <section>
            <p>
              Der Schutz Ihrer persönlichen Daten ist uns wichtig. Wir verarbeiten Ihre Daten
              ausschließlich auf Grundlage der gesetzlichen Bestimmungen (DSGVO, BDSG, TTDSG).
              Im Folgenden informieren wir Sie darüber, welche personenbezogenen Daten wir auf
              dieser Website verarbeiten, zu welchem Zweck und welche Rechte Ihnen zustehen.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl text-brand-text mt-8">1. Verantwortliche Stelle</h2>
            <p className="mt-3">
              Verantwortlich im Sinne der DSGVO ist:
            </p>
            <p className="mt-3">
              Trendgut (Einzelunternehmen)<br />
              Inhaber: Menal Zeynal Akkurt<br />
              handelnd unter der Marke „Strombaron"<br />
              Westring 117<br />
              32051 Herford<br />
              NRW, Deutschland
            </p>
            <p className="mt-3">
              Telefon: <a href="tel:+491728246564" className="text-brand-text hover:text-brand-energyHover underline">0172 824 6564</a><br />
              E-Mail: <a href="mailto:info@strombaron.de" className="text-brand-text hover:text-brand-energyHover underline">info@strombaron.de</a>
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl text-brand-text mt-8">2. Zweck der Datenverarbeitung</h2>
            <p className="mt-3">Die Website verarbeitet personenbezogene Daten zu folgenden Zwecken:</p>
            <ul className="mt-3 list-disc pl-6 space-y-1">
              <li>Vermittlung von Strom- und Gastarifen</li>
              <li>Bearbeitung von Kundenanfragen</li>
              <li>Erstellung individueller, manueller Angebote nach Upload einer Rechnung</li>
              <li>Kontaktaufnahme per E-Mail und WhatsApp</li>
              <li>Kundenkommunikation</li>
              <li>Verbesserung der Website (Analyse / Statistik)</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-2xl text-brand-text mt-8">3. Verarbeitete Daten</h2>
            <p className="mt-3">Wir verarbeiten folgende Kategorien personenbezogener Daten:</p>
            <ul className="mt-3 list-disc pl-6 space-y-1">
              <li>Name (optional)</li>
              <li>E-Mail-Adresse</li>
              <li>Telefonnummer (optional; Pflicht bei Wahl der WhatsApp-Option)</li>
              <li>Postleitzahl</li>
              <li>Hochgeladene Dateien (Strom- und Gasrechnungen als PDF, JPG oder PNG)</li>
              <li>IP-Adresse und technische Verbindungsdaten</li>
              <li>Nutzungsdaten (z. B. Seitenaufrufe, Klickverhalten)</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-2xl text-brand-text mt-8">4. Rechtsgrundlagen</h2>
            <p className="mt-3">Die Verarbeitung Ihrer Daten erfolgt auf folgenden Rechtsgrundlagen gemäß Art. 6 DSGVO:</p>
            <ul className="mt-3 list-disc pl-6 space-y-1">
              <li><strong className="text-brand-text">Art. 6 Abs. 1 lit. b DSGVO</strong> – zur Erfüllung vorvertraglicher Maßnahmen und Vertragsanbahnung</li>
              <li><strong className="text-brand-text">Art. 6 Abs. 1 lit. a DSGVO</strong> – auf Grundlage Ihrer ausdrücklichen Einwilligung (insbesondere bei Upload und WhatsApp-Nutzung)</li>
              <li><strong className="text-brand-text">Art. 6 Abs. 1 lit. f DSGVO</strong> – berechtigtes Interesse an Analyse und Verbesserung unseres Angebots</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-2xl text-brand-text mt-8">5. Datenweitergabe</h2>
            <p className="mt-3">
              Ihre Daten werden ausschließlich zur Bearbeitung Ihrer Anfrage verwendet. Eine
              Weitergabe erfolgt nur an folgende Empfänger:
            </p>
            <ul className="mt-3 list-disc pl-6 space-y-1">
              <li>
                <strong className="text-brand-text">Teleson AG</strong> –
                im Rahmen der Vermittlung als unserem Vertragspartner
              </li>
              <li>
                Energieversorger – zur Erstellung eines individuellen Tarifangebots auf Ihre Anfrage hin
              </li>
            </ul>
            <p className="mt-3">
              Eine Weitergabe an unbeteiligte Dritte außerhalb dieser Vermittlungsabwicklung findet
              nicht statt.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl text-brand-text mt-8">6. Upload von Dokumenten</h2>
            <p className="mt-3">
              Nutzer können über unser Formular Strom- oder Gasrechnungen als PDF, JPG oder PNG
              hochladen – alternativ per Kamerafoto über das Mobilgerät. Diese Daten werden:
            </p>
            <ul className="mt-3 list-disc pl-6 space-y-1">
              <li>verschlüsselt übertragen (SSL/TLS)</li>
              <li>auf unserem Server sicher gespeichert</li>
              <li>per E-Mail an den Betreiber zur manuellen Angebotserstellung übermittelt</li>
              <li>ausschließlich zur Erstellung Ihres individuellen und unverbindlichen Angebots genutzt</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-2xl text-brand-text mt-8">7. WhatsApp-Nutzung (Hauptkommunikationskanal)</h2>
            <p className="mt-3">
              Strombaron nutzt WhatsApp als primären Kommunikationskanal für Kundenanfragen und
              Angebotserstellung. Wenn Sie auf einen WhatsApp-Button auf unserer Website klicken,
              werden Sie zur Anwendung „WhatsApp Messenger" weitergeleitet, betrieben von der{" "}
              <strong className="text-brand-text">Meta Platforms Ireland Ltd.</strong>, Merrion
              Road, Dublin 4, D04 X2K5, Irland.
            </p>
            <p className="mt-3">
              <strong className="text-brand-text">Datenkategorien</strong>: Mobilfunknummer, von
              Ihnen übermittelte Inhalte (Texte, Fotos, PDF-Dateien wie Strom- oder Gasrechnungen),
              Profilbild (sofern bei WhatsApp aktiviert), Online-Status, Zeitstempel.
            </p>
            <p className="mt-3">
              <strong className="text-brand-text">Datenübertragung</strong>: Meta verarbeitet Daten
              auch außerhalb der EU (insbesondere in den USA). WhatsApp-Nachrichten sind zwar
              Ende-zu-Ende verschlüsselt, Metadaten (z. B. wer wann mit wem kommuniziert) werden
              jedoch durch Meta verarbeitet.
            </p>
            <p className="mt-3">
              <strong className="text-brand-text">Rechtsgrundlage</strong>: Ihre Einwilligung gemäß
              Art. 6 Abs. 1 lit. a DSGVO. Diese erteilen Sie aktiv durch das Klicken eines
              WhatsApp-Buttons und das anschließende Senden einer Nachricht. Sie können die
              Einwilligung jederzeit widerrufen, indem Sie uns unter info@strombaron.de
              kontaktieren oder den Chat in WhatsApp löschen.
            </p>
            <p className="mt-3">
              <strong className="text-brand-text">Alternative Kontaktwege</strong>: Wenn Sie WhatsApp
              nicht nutzen möchten, erreichen Sie uns selbstverständlich auch per E-Mail unter{" "}
              info@strombaron.de oder telefonisch unter 0172 824 6564.
            </p>
            <p className="mt-3">
              Weitere Informationen finden Sie in der Datenschutzerklärung von WhatsApp/Meta:{" "}
              <a href="https://www.whatsapp.com/legal/privacy-policy-eea" target="_blank" rel="noopener noreferrer" className="text-brand-text hover:text-brand-energyHover underline">
                whatsapp.com/legal/privacy-policy-eea
              </a>
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl text-brand-text mt-8">8. Kontaktformular und E-Mail</h2>
            <p className="mt-3">
              Bei Anfragen per Kontaktformular oder E-Mail werden Ihre Angaben zur Bearbeitung
              der Anfrage und für den Fall von Anschlussfragen gespeichert. Diese Daten werden
              ohne Ihre ausdrückliche Einwilligung nicht weitergegeben.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl text-brand-text mt-8">9. Tracking / Analytics</h2>
            <p className="mt-3">
              Diese Website nutzt Analyse-Tools (z. B. Google Analytics 4 der Google Ireland
              Limited, Gordon House, Barrow Street, Dublin 4, Irland) zur Verbesserung der
              Nutzererfahrung. Dabei können IP-Adressen (in gekürzter Form) und Nutzungsverhalten
              verarbeitet werden. Die Nutzung erfolgt ausschließlich nach Ihrer Einwilligung im
              Cookie-Banner (Art. 6 Abs. 1 lit. a DSGVO, § 25 Abs. 1 TTDSG). Sie können Ihre
              Einwilligung jederzeit widerrufen, indem Sie die Cookie-Einstellungen aktualisieren.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl text-brand-text mt-8">10. SSL-Verschlüsselung</h2>
            <p className="mt-3">
              Diese Website nutzt aus Sicherheitsgründen eine SSL-/TLS-Verschlüsselung zum Schutz
              der Übertragung vertraulicher Inhalte (z. B. Anfragen und Datei-Uploads). Eine
              verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers mit
              „https://" beginnt.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl text-brand-text mt-8">11. Speicherdauer</h2>
            <p className="mt-3">
              Personenbezogene Daten werden nur so lange gespeichert, wie es für die Bearbeitung
              Ihrer Anfrage und zur Erfüllung gesetzlicher Aufbewahrungspflichten (z. B. HGB, AO)
              erforderlich ist. Nach Ablauf dieser Fristen werden die Daten gelöscht oder
              anonymisiert.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl text-brand-text mt-8">12. Ihre Rechte</h2>
            <p className="mt-3">Ihnen stehen jederzeit folgende Rechte zu:</p>
            <ul className="mt-3 list-disc pl-6 space-y-1">
              <li>Recht auf Auskunft (Art. 15 DSGVO)</li>
              <li>Recht auf Berichtigung (Art. 16 DSGVO)</li>
              <li>Recht auf Löschung (Art. 17 DSGVO)</li>
              <li>Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
              <li>Recht auf Datenübertragbarkeit (Art. 20 DSGVO)</li>
              <li>Recht auf Widerruf einer erteilten Einwilligung (Art. 7 Abs. 3 DSGVO)</li>
              <li>Recht auf Beschwerde bei einer Aufsichtsbehörde (Art. 77 DSGVO)</li>
            </ul>
            <p className="mt-3">
              Zuständige Aufsichtsbehörde für den Betreiber ist die Landesbeauftragte für Datenschutz
              und Informationsfreiheit Nordrhein-Westfalen (LDI NRW), Kavalleriestr. 2–4, 40213 Düsseldorf.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl text-brand-text mt-8">13. Kontakt für Datenschutzanfragen</h2>
            <p className="mt-3">
              Für Fragen zum Datenschutz oder zur Ausübung Ihrer Rechte kontaktieren Sie uns bitte unter:<br />
              E-Mail: <a href="mailto:info@strombaron.de" className="text-brand-text hover:text-brand-energyHover underline">info@strombaron.de</a>
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl text-brand-text mt-8">14. Hinweis zur Zusammenarbeit</h2>
            <p className="mt-3">
              Die Vermittlung erfolgt im Rahmen eines Handelsvertretermodells in Zusammenarbeit
              mit der Teleson AG. Strombaron ist kein eigener Energieversorger; Verträge kommen
              ausschließlich zwischen Ihnen und dem jeweiligen Energieversorgungsunternehmen zustande.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl text-brand-text mt-8">15. Änderungen dieser Datenschutzerklärung</h2>
            <p className="mt-3">
              Wir passen diese Datenschutzerklärung an, sobald Änderungen der Datenverarbeitung
              dies erforderlich machen. Die jeweils aktuelle Fassung finden Sie auf dieser Seite.
            </p>
            <p className="mt-3 text-sm">Stand: {new Date().toLocaleDateString("de-DE", { year: "numeric", month: "long" })}</p>
          </section>
        </div>
      </div>
    </div>
  );
}
